import { useMemo } from "react";

import { APPEARANCE, useThemeContext } from "@/react/providers/Theme";

export const appearanceThemes = {
  flat: "flat",
  stripe: "stripe",
  night: "night",
} as const;
export type StripeTheme =
  (typeof appearanceThemes)[keyof typeof appearanceThemes];

export const useThemeContextForStripeElements = (): {
  stripeTheme: StripeTheme;
} => {
  const { currentAppearance } = useThemeContext();

  return useMemo(() => {
    switch (currentAppearance) {
      case APPEARANCE.LIGHT:
        return { stripeTheme: appearanceThemes.stripe };
      case APPEARANCE.DARK:
        return { stripeTheme: appearanceThemes.night };
      default:
        return { stripeTheme: appearanceThemes.stripe };
    }
  }, [currentAppearance]);
};
